import { render } from "./Breadcrumbs.vue?vue&type=template&id=b8af126a"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=b8af126a&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script